module.exports = __webpack_public_path__ + "img/spei.cead58a.svg";